export default __webpack_public_path__ + "static/media/hindu.62d1bed088eba88471914bdd20853e42.png";